import {
  DistanceUnit,
  WeightUnit,
} from "@api/graphql/generated/generated-types";
import { useAuth } from "@src/common/hooks/useAuth";
import { CourierLocale, FormatCurrencyOptions } from "./types";
import { formatCurrency as formatCurrencyValue } from "./formatters/currency";
import {
  formatDistance as formatDistanceValue,
  milesToDisplay as milesToDisplayValue,
  displayToMiles as displayToMilesValue,
  perMileToDisplay as perMileToDisplayValue,
  displayToPerMile as displayToPerMileValue,
} from "./formatters/distance";
import { formatWeight as formatWeightValue } from "./formatters/weight";
import {
  weightUnitLabel,
  distanceUnitLabel,
  distanceUnitLabelFull,
  perDistanceUnitLabel,
  formatSpeed as formatSpeedValue,
} from "./formatters/labels";

export const useCourierLocale = (): CourierLocale => {
  const { courier } = useAuth();

  const currencyDisplay = courier?.courier?.currencyDisplay ?? "$";
  const distanceUnit = courier?.courier?.distanceUnit ?? DistanceUnit.Miles;
  const weightUnit = courier?.courier?.weightUnit ?? WeightUnit.Lbs;

  return {
    currencyDisplay,
    distanceUnit,
    weightUnit,
    formatCurrency: (amount, options?: FormatCurrencyOptions) =>
      formatCurrencyValue(amount, currencyDisplay, options),
    formatDistance: (meters) => formatDistanceValue(meters, distanceUnit),
    formatWeight: (pounds) => formatWeightValue(pounds, weightUnit),
    formatSpeed: (secondsPerMile) =>
      formatSpeedValue(secondsPerMile, distanceUnit),
    milesToDisplay: (miles) => milesToDisplayValue(miles, distanceUnit),
    displayToMiles: (value) => displayToMilesValue(value, distanceUnit),
    perMileToDisplay: (ratePerMile) => perMileToDisplayValue(ratePerMile, distanceUnit),
    displayToPerMile: (rate) => displayToPerMileValue(rate, distanceUnit),
    weightLabel: weightUnitLabel(weightUnit),
    distanceLabel: distanceUnitLabel(distanceUnit),
    distanceLabelFull: distanceUnitLabelFull(distanceUnit),
    perDistanceLabel: perDistanceUnitLabel(distanceUnit),
  };
};
